document.addEventListener('DOMContentLoaded', function () {
	const container = document.querySelector('.wp-block-ifdigitalxsemmel-if-semmel-connect-us');
	if (!container) return;

	const tourFilterButtons = container.querySelectorAll('.semmel-connect--filter-tour li');
	const locationFilterButtons = container.querySelectorAll('.semmel-connect--filter li');
	const events = container.querySelectorAll('.semmel-connect--event');

	let activeTour = 'all';
	let activeLocation = 'all';

	function filterEvents() {
		events.forEach(event => {
			const eventTour = event.getAttribute('data-tour');
			const eventLocation = event.getAttribute('data-location');

			const matchesTour = activeTour === 'all' || eventTour === activeTour;
			const matchesLocation = activeLocation === 'all' || eventLocation === activeLocation;

			event.style.display = matchesTour && matchesLocation ? 'grid' : 'none';
		});
	}

	function updateActiveState(buttons, activeValue) {
		buttons.forEach(btn => {
			const value = btn.getAttribute('data-tour') || btn.getAttribute('data-location');
			btn.classList.toggle('active', value === activeValue);
		});
	}

	// Tour-Filter
	tourFilterButtons.forEach(button => {
		button.addEventListener('click', () => {
			activeTour = button.getAttribute('data-tour');
			updateActiveState(tourFilterButtons, activeTour);
			filterEvents();
		});
	});

	// Location-Filter
	locationFilterButtons.forEach(button => {
		button.addEventListener('click', () => {
			activeLocation = button.getAttribute('data-location');
			updateActiveState(locationFilterButtons, activeLocation);
			filterEvents();
		});
	});

	// Initiale Filterung
	filterEvents();
});